module.exports = __webpack_public_path__ + "img/grip5.d495225a.png";